import React from "react";
import { Route, Switch } from "react-router-dom";

import ThemeWrapper from "../../theme/ThemeWrapper";
import { ORDERS_AUTH_ROUTES } from "../../constants/ordersAuth";
import ordersAuthContainer from "../../containers/ordersAuth/ordersAuthContainer";
import ordersAuthOtpContainer from "../../containers/ordersAuth/ordersAuthOtpContainer";
import orderSuccessContainer from "../../containers/ordersAuth/orderSuccessContainer";
import ErrorScreen from "./ErrorScreen";

const OrdersAuth = () => {
  return (
    <Switch>
      <ThemeWrapper>
        <Route
          path={ORDERS_AUTH_ROUTES.LANDING}
          exact
          component={ordersAuthContainer}
        />
        <Route
          path={ORDERS_AUTH_ROUTES.OTP}
          exact
          component={ordersAuthOtpContainer}
        />
        <Route
          path={ORDERS_AUTH_ROUTES.SUCCESS}
          exact
          component={orderSuccessContainer}
        />
        <Route path={ORDERS_AUTH_ROUTES.ERROR} exact component={ErrorScreen} />
      </ThemeWrapper>
    </Switch>
  );
};

export default OrdersAuth;
